module.exports = __webpack_public_path__ + "static/media/person.fba2776d.png";